import { render, staticRenderFns } from "./RecruiterApplyCard.vue?vue&type=template&id=e8b3e1be&scoped=true&"
import script from "./RecruiterApplyCard.vue?vue&type=script&lang=ts&"
export * from "./RecruiterApplyCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecruiterApplyCard.vue?vue&type=style&index=0&id=e8b3e1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b3e1be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VBtn,VImg})
